<template>
  <v-card color="primary" class="rounded-xxl py-16 px-10">
    <v-card class="pt-7 pb-16" color="#fff">
      <!-- search box -->
      <toolBarBox
          :ids="ids"
          @clearIdList="clearIds"
          @getData="getData"
      />
      <!-- data table -->
      <dataTable
        :categoryItems="categoryItems"
        :loading="loading"
        :ids="ids"
        :totalPages="totalPages"
        @getData="getData"
        @updateIds="updateIds"
      />
    </v-card>
  </v-card>
</template>

<script>
import toolBarBox from "@/components/Courses/Category/filter.vue";
import dataTable from "@/components/Courses/Category/table.vue";
import courseApi from "@/Services/modules/courses"
export default {
  name: "categoryList",
  components: {toolBarBox, dataTable},
  data() {
    return {
      ids: [],
      filterSearch: {
        page: Number(this.$route.query.page) || 1,
        search: this.$route.query.search || "",
        is_archive: false
      },
      totalPages: 1,
      categoryItems: [],
      loading: false,
    }
  },
  mounted() {
    this.getData(this.filterSearch)
  },
  methods: {
    getData(searchParams) {
      this.loading = true
      courseApi.getAllCategory(searchParams).then(res => {
        this.categoryItems = res.data.results
        this.totalPages = res.data.page_count
        this.ids = []
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    clearIds() {
      this.ids = []
    },
    updateIds(ids) {
      this.ids = ids
    }
  }
}
</script>

<style scoped>

</style>